var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 1.33333C5.79082 1.33333 3.99996 3.12419 3.99996 5.33333C3.99996 7.54247 5.79082 9.33333 7.99996 9.33333C8.77585 9.33333 9.50015 9.11242 10.1134 8.73006C10.1465 8.70385 10.1823 8.68067 10.2203 8.66098C11.2934 7.94358 12 6.72098 12 5.33333C12 3.12419 10.2091 1.33333 7.99996 1.33333ZM11.241 9.56922C12.5131 8.59447 13.3333 7.05969 13.3333 5.33333C13.3333 2.38781 10.9455 0 7.99996 0C5.05444 0 2.66663 2.38781 2.66663 5.33333C2.66663 7.06003 3.48718 8.59507 4.75962 9.56979L4.00576 15.2456C3.97206 15.4993 4.08664 15.75 4.3006 15.8905C4.51456 16.0311 4.79011 16.0367 5.00962 15.905L7.99996 14.1108L10.9903 15.905C11.2098 16.0367 11.4853 16.0311 11.6993 15.8906C11.9132 15.75 12.0278 15.4994 11.9942 15.2457L11.241 9.56922ZM9.99069 10.2827C9.37559 10.5304 8.70369 10.6667 7.99996 10.6667C7.2965 10.6667 6.62485 10.5305 6.00994 10.283L5.50959 14.0501L7.65696 12.7617C7.86808 12.635 8.13183 12.635 8.34296 12.7617L10.4905 14.0502L9.99069 10.2827Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.fabcec15.svg";
export { ForwardRef as ReactComponent };